import assignmentTeacher from '../sub_modules/teacher/Repositories/index'
import assignmentStudent from '../sub_modules/student/Repositories/index'
export default {
  ...assignmentTeacher,
  ...assignmentStudent
}
